import axios from 'axios';

export const ApiCall = async (method, path, config, data) => {
  // const url = `http://localhost:5000/${ path }`
  //const url = `http://localhost:5000/${ path }/`
  const url = `https://voiceapi.aicte-india.org/${path}`;
  try {
    const response = await axios[method](url, data, { config });
    return response.data;
  } catch (error) {
    console.log(error, 'error message');
  }
};
export const ApiCall2 = async (method, path, config, data) => {
  // const url = `http://localhost:5000/${ path }`
  //const url = `http://localhost:5000/${ path }/`
  const url = `https://anuvadini-services.aicte-india.org/api/${path}`;
  try {
    const response = await axios[method](url, data, {
      headers: {
        authorization: 'Bearer 2c7d8e9f2c45b1a7d6e2f9a4b3c7d8e',
      },
    });
    return response.data;
  } catch (error) {
    console.log(error, 'error message');
  }
};
